import { BaseService } from "../BaseService";
import { AuthService } from "../auth/auth.service";
import { environment } from '../../../../src/environments/environment';
import { HttpClient } from "@angular/common/http";
import { Router } from '@angular/router';
import { Observable, of, throwError } from "rxjs";
import { catchError, concatMap, delay, map, retryWhen, take } from 'rxjs/operators';
import { ApiResult } from "../../models/ApiResult";
import { Injectable } from "@angular/core";
import { AdminDashboardModel } from "../../models/api/AdminDashboardModel";
import { AdminClockedInTherapistsModel } from "../../models/api/AdminClockedInTherapistsModel";

@Injectable({
  providedIn: 'root'
})

export class DashboardService extends BaseService {
    private urlPart: string = 'Dashboard';
    constructor(private h: HttpClient, private r: Router, private a: AuthService) {
        super(h, r, a);
         this.apiSegmentUrl = this.urlPart;
    };


  /// <summary>
  /// GET: Gets the Clocked in therapist info
  /// /Dashboard/Admin/clockedin
  /// </summary>
  /// <returns></returns>
  public getClockedInTherapists(): Observable<AdminClockedInTherapistsModel[]> {

    const url = `${super.getBaseUrl() + '/admin/clockedin'}`;



    if (!environment.production)
      console.log("ClockedInTherapists:Calling " + url);

    return this.h.get<AdminClockedInTherapistsModel[]>(url)
      .pipe(
        map(next => next),
        retryWhen(errors =>
          errors.pipe(
            concatMap((error, count) => {
              if (count > this.RETRY_CEILING) return throwError(error);
              return this.tokenCheckAndRefresh(error);
            }),
            delay(1000),
          ),
        ),
        catchError(this.errorHandler)
      );
  }
  

  /// <summary>
  /// GET: Gets the Admin Dashboard info
  /// /Dashboard/Admin/{lastXHours}
  /// </summary>
  /// <returns></returns>
  public getAdminDashboard(lastXHours: number = 24): Observable<AdminDashboardModel> {

    const url = `${super.getBaseUrl() + '/admin/' + lastXHours}`;

    if (!environment.production)
      console.log("Dashboard:Calling " + url);

    return this.h.get<AdminDashboardModel>(url)
      .pipe(
        map(next => {
          let o: AdminDashboardModel = Object.assign(new AdminDashboardModel(), next);
          return o;
        }),
        retryWhen(errors =>
          errors.pipe(
            concatMap((error, count) => {
              if (count > this.RETRY_CEILING) return throwError(error);
              return this.tokenCheckAndRefresh(error);
            }),
            delay(1000),
          ),
        ),
        catchError(this.errorHandler)
      );
  }

  /// <summary>
  /// GET: Gets the therapists on break info
  /// /Dashboard/Admin/therapistsonbreak
  /// </summary>
  /// <returns></returns>
  public getTherapistsOnBreak(): Observable<AdminClockedInTherapistsModel[]> {

    const url = `${super.getBaseUrl() + '/admin/therapistsonbreak'}`;



    if (!environment.production)
      console.log("TherapistsOnBreak:Calling " + url);

    return this.h.get<AdminClockedInTherapistsModel[]>(url)
      .pipe(
        map(next => next),
        retryWhen(errors =>
          errors.pipe(
            concatMap((error, count) => {
              if (count > this.RETRY_CEILING) return throwError(error);
              return this.tokenCheckAndRefresh(error);
            }),
            delay(1000),
          ),
        ),
        catchError(this.errorHandler)
      );
  }

  /// <summary>
  /// GET: Gets the therapists on massage info
  /// /Dashboard/Admin/therapistsonmassage
  /// </summary>
  /// <returns></returns>
  public getTherapistsOnMassage(): Observable<AdminClockedInTherapistsModel[]> {

    const url = `${super.getBaseUrl() + '/admin/therapistsonmassage'}`;



    if (!environment.production)
      console.log("TherapistsOnMassage:Calling " + url);

    return this.h.get<AdminClockedInTherapistsModel[]>(url)
      .pipe(
        map(next => next),
        retryWhen(errors =>
          errors.pipe(
            concatMap((error, count) => {
              if (count > this.RETRY_CEILING) return throwError(error);
              return this.tokenCheckAndRefresh(error);
            }),
            delay(1000),
          ),
        ),
        catchError(this.errorHandler)
      );
  }

  /// <summary>
  /// GET: Gets the therapistswaiting info
  /// /Dashboard/Admin/therapistswaiting
  /// </summary>
  /// <returns></returns>
  public getTherapistsWaiting(): Observable<AdminClockedInTherapistsModel[]> {

    const url = `${super.getBaseUrl() + '/admin/therapistswaiting'}`;



    if (!environment.production)
      console.log("TherapistsWaiting:Calling " + url);

    return this.h.get<AdminClockedInTherapistsModel[]>(url)
      .pipe(
        map(next => next),
        retryWhen(errors =>
          errors.pipe(
            concatMap((error, count) => {
              if (count > this.RETRY_CEILING) return throwError(error);
              return this.tokenCheckAndRefresh(error);
            }),
            delay(1000),
          ),
        ),
        catchError(this.errorHandler)
      );
  }

  /// <summary>
  /// GET: Gets the Admin Dashboard info
  /// /Dashboard/Admin/{lastXHours}
  /// </summary>
  /// <returns></returns>
  public getEventDashboard(eventID: number, lastXHours: number = 24): Observable<AdminDashboardModel> {

    const url = `${super.getBaseUrl() + '/adminbyevent/' + eventID + '/' + lastXHours}`;

    if (!environment.production)
      console.log("EventDashboard:Calling " + url);

    return this.h.get<AdminDashboardModel>(url)
      .pipe(
        map(next => {
          let o: AdminDashboardModel = Object.assign(new AdminDashboardModel(), next);
          return o;
        }),
        retryWhen(errors =>
          errors.pipe(
            concatMap((error, count) => {
              if (count > this.RETRY_CEILING) return throwError(error);
              return this.tokenCheckAndRefresh(error);
            }),
            delay(1000),
          ),
        ),
        catchError(this.errorHandler)
      );
  }

  /// <summary>
  /// GET: Gets the therapists on break info, by event
  /// /Dashboard/Event/therapistsonbreak
  /// </summary>
  /// <returns></returns>
  public getTherapistsOnBreakByEvent(eventID: number): Observable<AdminClockedInTherapistsModel[]> {

    const url = `${super.getBaseUrl() + '/admin/therapistsonbreakbyevent/' + eventID}`;



    if (!environment.production)
      console.log("TherapistsOnBreakByEvent:Calling " + url);

    return this.h.get<AdminClockedInTherapistsModel[]>(url)
      .pipe(
        map(next => next),
        retryWhen(errors =>
          errors.pipe(
            concatMap((error, count) => {
              if (count > this.RETRY_CEILING) return throwError(error);
              return this.tokenCheckAndRefresh(error);
            }),
            delay(1000),
          ),
        ),
        catchError(this.errorHandler)
      );
  }

  /// <summary>
  /// GET: Gets the Clocked in therapist info, by event
  /// /Dashboard/admin/clockedinbyevent
  /// </summary>
  /// <returns></returns>
  public getClockedInTherapistsByEvent(eventID: number): Observable<AdminClockedInTherapistsModel[]> {

    const url = `${super.getBaseUrl() + '/admin/clockedinbyevent/' + eventID}`;



    if (!environment.production)
      console.log("ClockedInTherapistsByEvent:Calling " + url);

    return this.h.get<AdminClockedInTherapistsModel[]>(url)
      .pipe(
        map(next => next),
        retryWhen(errors =>
          errors.pipe(
            concatMap((error, count) => {
              if (count > this.RETRY_CEILING) return throwError(error);
              return this.tokenCheckAndRefresh(error);
            }),
            delay(1000),
          ),
        ),
        catchError(this.errorHandler)
      );
  }

  /// <summary>
  /// GET: Gets the attending therapist info, by event
  /// /Dashboard/admin/presentbyevent
  /// </summary>
  /// <returns></returns>
  public getPresentTherapistsByEvent(eventID: number): Observable<AdminClockedInTherapistsModel[]> {

    const url = `${super.getBaseUrl() + '/admin/presentbyevent/' + eventID}`;



    if (!environment.production)
      console.log("PresentTherapistsByEvent:Calling " + url);

    return this.h.get<AdminClockedInTherapistsModel[]>(url)
      .pipe(
        map(next => next),
        retryWhen(errors =>
          errors.pipe(
            concatMap((error, count) => {
              if (count > this.RETRY_CEILING) return throwError(error);
              return this.tokenCheckAndRefresh(error);
            }),
            delay(1000),
          ),
        ),
        catchError(this.errorHandler)
      );
  }

  /// <summary>
  /// GET: Gets the therapists on massage info, by event
  /// /Dashboard/Event/therapistsonmassage
  /// </summary>
  /// <returns></returns>
  public getTherapistsOnMassageByEvent(eventID: number): Observable<AdminClockedInTherapistsModel[]> {

    const url = `${super.getBaseUrl() + '/admin/therapistsonmassagebyevent/' + eventID}`;



    if (!environment.production)
      console.log("TherapistsOnMassageByEvent:Calling " + url);

    return this.h.get<AdminClockedInTherapistsModel[]>(url)
      .pipe(
        map(next => next),
        retryWhen(errors =>
          errors.pipe(
            concatMap((error, count) => {
              if (count > this.RETRY_CEILING) return throwError(error);
              return this.tokenCheckAndRefresh(error);
            }),
            delay(1000),
          ),
        ),
        catchError(this.errorHandler)
      );
  }

  /// <summary>
  /// GET: Gets the therapistswaiting info, by event
  /// /Dashboard/Event/therapistswaiting
  /// </summary>
  /// <returns></returns>
  public getTherapistsWaitingByEvent(eventID: number): Observable<AdminClockedInTherapistsModel[]> {

    const url = `${super.getBaseUrl() + '/admin/therapistswaitingbyevent/' + eventID}`;



    if (!environment.production)
      console.log("TherapistsWaitingByEvent:Calling " + url);

    return this.h.get<AdminClockedInTherapistsModel[]>(url)
      .pipe(
        map(next => next),
        retryWhen(errors =>
          errors.pipe(
            concatMap((error, count) => {
              if (count > this.RETRY_CEILING) return throwError(error);
              return this.tokenCheckAndRefresh(error);
            }),
            delay(1000),
          ),
        ),
        catchError(this.errorHandler)
      );
  }
}
